import { create } from 'zustand'
import { bootstrapSchema } from './schema'

interface CacheState {
  ready: boolean
  initError: string | null
  setReady: (ready: boolean, err?: string | null) => void
}

export const useCacheStore = create<CacheState>((set) => ({
  ready: false,
  initError: null,
  setReady: (ready, err = null) => set({ ready, initError: err }),
}))

let initPromise: Promise<void> | null = null

export function initCache(): Promise<void> {
  if (initPromise) return initPromise
  initPromise = (async () => {
    try {
      await bootstrapSchema()
      useCacheStore.getState().setReady(true)
    } catch (err) {
      const msg = err instanceof Error ? err.message : String(err)
      console.error('[cache] init failed:', err)
      useCacheStore.getState().setReady(false, msg)
      throw err
    }
  })()
  return initPromise
}
